export default [
  {
    path: '/reportRepairManage',
    component: () => import('../pages/propertyManage/reportRepairManage.vue'),
    name: 'reportRepairManage',
    title: '报事报修',
    meta: {
      title: '报事报修',
    },
  },
  {
    path: '/payCostManage',
    component: () => import('../pages/propertyManage/payCostManage.vue'),
    name: 'payCostManage',
    title: '物业缴费',
    meta: {
      title: '物业缴费',
    },
  },
  {
    path: '/propertyCount',
    component: () => import('../pages/propertyManage/propertyCount.vue'),
    name: 'propertyCount',
    title: '物业功能使用统计',
    meta: {
      title: '物业功能使用统计',
    },
  },
  {
    path: '/houseRepossessionManage',
    component: () =>
      import(
        '../pages/propertyManage/houseRepossession/houseRepossessionManage.vue'
      ),
    name: 'houseRepossessionManage',
    title: '收房活动管理',
    meta: {
      title: '收房活动管理',
    },
  },
  {
    path: '/houseRepossessionOrder',
    component: () =>
      import(
        '../pages/propertyManage/houseRepossession/houseRepossessionOrder.vue'
      ),
    name: 'houseRepossessionOrder',
    title: '客户收房预约',
    meta: {
      title: '客户收房预约',
    },
  },
  {
    path: '/visitorBillManage',
    component: () => import('../pages/propertyManage/visitorBillManage.vue'),
    name: 'visitorBillManage',
    title: '访客邀约记录',
    meta: {
      title: '访客邀约记录',
    },
  },
  {
    path: '/smartLockBill',
    component: () => import('../pages/propertyManage/smartLockBill.vue'),
    name: 'smartLockBill',
    title: '门禁开锁记录',
    meta: {
      title: '门禁开锁记录',
    },
  },
  {
    path: '/lockPermissionManage',
    component: () => import('../pages/propertyManage/lockPermissionManage.vue'),
    name: 'lockPermissionManage',
    title: '门禁权限管理',
    meta: {
      title: '门禁权限管理',
    },
  },
  {
    path: '/evaluateLabelManage',
    component: () => import('../pages/propertyManage/evaluateLabelManage.vue'),
    name: 'evaluateLabelManage',
    title: '评价标签管理',
    meta: {
      title: '评价标签管理',
    },
  },
  {
    path: '/suggestionManage',
    component: () => import('../pages/propertyManage/suggestionManage.vue'),
    name: 'suggestionManage',
    title: '投诉建议',
    meta: {
      title: '投诉建议',
    },
  },
  {
    path: '/propertyUserManage',
    component: () => import('../pages/propertyManage/propertyUserManage.vue'),
    name: 'propertyUserManage',
    title: '物业人员管理',
    meta: {
      title: '物业人员管理',
    },
  },
  {
    path: '/deliverPayment',
    component: () => import('../pages/propertyManage/deliverPayment.vue'),
    name: 'deliverPayment',
    title: '缴费账单管理',
    meta: {
      title: '缴费账单管理',
    },
  },
  {
    path: '/propertyConfig',
    component: () => import('../pages/propertyManage/propertyConfig.vue'),
    name: 'propertyConfig',
    title: '物业功能配置',
    meta: {
      title: '物业功能配置',
    },
  },
  {
    path: '/carOrderManage',
    component: () => import('../pages/propertyManage/carOrderManage.vue'),
    name: 'carOrderManage',
    title: '用车呼叫管理',
    meta: {
      title: '用车呼叫管理',
    },
  },
  {
    path: '/carTimetable',
    component: () => import('../pages/propertyManage/carTimetable.vue'),
    name: 'carTimetable',
    title: '时刻表管理',
    meta: {
      title: '时刻表管理',
    },
  },
]
